<template>
  <main class="q-login-page">
    <!-- Background glow (safe) -->
    <div class="q-bg" aria-hidden="true">
      <span class="q-orb q-orb-1"></span>
      <span class="q-orb q-orb-2"></span>
      <span class="q-orb q-orb-3"></span>
      <span class="q-grid"></span>
    </div>

    <div class="container q-wrap">
      <div class="row justify-content-center">
        <div class="col-12 col-md-10 col-lg-6 col-xl-5">
          <div class="q-card">
            <!-- Top -->
            <div class="q-top">
              <div class="q-brandrow">
                 <span class="q-logo">
          <img src="../assets/mitton_logo.png" alt="Quick Quiz AI logo" />
        </span>
                <div>
                  <div class="q-brand">Quick Quiz AI</div>
                  <div class="q-brandsub">Sign in to continue</div>
                </div>
              </div>

              <span class="q-pill">
                <i class="bi bi-shield-lock me-2"></i>Secure login
              </span>
            </div>

            <!-- Form (UI only) -->
            <form class="mt-4" @submit.prevent>
              <div class="q-field">
                <label class="q-label" for="email">Email</label>
                <div class="q-inputwrap">
                  <i class="bi bi-envelope q-ic"></i>
                  <input
                    id="email"
                    v-model="email"
                    class="form-control q-input"
                    type="email"
                    placeholder="you@example.com"
                    autocomplete="email"
                  />
                </div>
              </div>

              <div class="q-field mt-3">
                <label class="q-label" for="password">Password</label>
                <div class="q-inputwrap">
                  <i class="bi bi-lock q-ic"></i>
                  <input
                    id="password"
                    v-model="password"
                    class="form-control q-input"
                    :type="showPw ? 'text' : 'password'"
                    placeholder="••••••••"
                    autocomplete="current-password"
                  />
                  <button
                    class="btn q-eye"
                    type="button"
                    @click="showPw = !showPw"
                    :aria-label="showPw ? 'Hide password' : 'Show password'"
                  >
                    <i :class="showPw ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                  </button>
                </div>
              </div>

              <div class="d-flex justify-content-between align-items-center mt-3 q-meta">
                <label class="q-check">
                  <input class="form-check-input me-2" type="checkbox" v-model="remember" />
                  Remember me
                </label>

                <a class="q-link" href="#" @click.prevent>Forgot password?</a>
              </div>

              <button class="btn q-cta w-100 mt-4" type="submit">
                <i class="bi bi-box-arrow-in-right me-2"></i>Log In
              </button>

              <div class="q-divider my-4">
                <span>or</span>
              </div>

              <div class="d-grid gap-2">
                <button class="btn q-alt" type="button" @click.prevent>
                  <i class="bi bi-google me-2"></i>Continue with Google
                </button>
                <button class="btn q-alt" type="button" @click.prevent>
                  <i class="bi bi-apple me-2"></i>Continue with Apple
                </button>
              </div>

              <div class="q-foot mt-4">
                <span class="q-muted">New here?</span>
                <RouterLink class="q-link" to="/pricing">Start free trial</RouterLink>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "LoginView",
  data() {
    return {
      email: "",
      password: "",
      remember: true,
      showPw: false,
    };
  },
};
</script>

<style scoped>
.q-login-page {
  position: relative;
  min-height: 100vh;
  overflow-x: hidden;
  padding: 4rem 0 4.5rem;
}

.q-wrap {
  max-width: 72rem;
}

/* Background */
.q-bg {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: -1;
  overflow: hidden;
}

.q-orb {
  position: absolute;
  width: 30rem;
  height: 30rem;
  border-radius: 999px;
  filter: blur(4rem);
  opacity: 0.18;
  transform: translate3d(0, 0, 0);
  animation: q-drift 10s ease-in-out infinite alternate;
}
.q-orb-1 {
  top: -20%;
  left: -15%;
  background: rgba(45, 108, 255, 1);
}
.q-orb-2 {
  top: 10%;
  right: -18%;
  background: rgba(124, 58, 237, 1);
  animation-duration: 12s;
}
.q-orb-3 {
  bottom: -25%;
  left: 20%;
  background: rgba(255, 61, 141, 1);
  animation-duration: 14s;
}
.q-grid {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 30% 25%, rgba(255, 255, 255, 0.06), transparent 45%),
    radial-gradient(circle at 70% 55%, rgba(255, 255, 255, 0.05), transparent 55%);
  opacity: 0.35;
}

@keyframes q-drift {
  0% { transform: translate3d(0, 0, 0) scale(1); }
  100% { transform: translate3d(1.5rem, -1rem, 0) scale(1.05); }
}

/* Card */
.q-card {
  border-radius: 1.75rem;
  padding: 1.6rem;
  background: rgba(255, 255, 255, 0.04);
  border: 0.0625rem solid rgba(255, 255, 255, 0.10);
  box-shadow: 0 1.75rem 4rem rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(1rem);
  -webkit-backdrop-filter: blur(1rem);
}

/* Top */
.q-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.q-brandrow {
  display: flex;
  align-items: center;
  gap: 0.85rem;
}

.q-mark {
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 1.15rem;
  background: linear-gradient(145deg, #2d6cff 0%, #7c3aed 55%, #ff3d8d 120%);
  box-shadow: 0 1.25rem 2.5rem rgba(0, 0, 0, 0.35);
}

.q-brand {
  font-weight: 950;
  letter-spacing: -0.03rem;
  color: rgba(255, 255, 255, 0.95);
  font-size: 1.15rem;
}
.q-brandsub {
  color: rgba(255, 255, 255, 0.65);
  font-weight: 800;
  font-size: 0.95rem;
  margin-top: 0.1rem;
}

.q-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.45rem 0.75rem;
  border-radius: 62.5rem;
  font-weight: 950;
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.88);
  background: rgba(255, 255, 255, 0.06);
  border: 0.0625rem solid rgba(255, 255, 255, 0.12);
}

/* Fields */
.q-field {
  width: 100%;
}

.q-label {
  color: rgba(255, 255, 255, 0.78);
  font-weight: 950;
  letter-spacing: -0.01rem;
  margin-bottom: 0.5rem;
  display: block;
}

.q-inputwrap {
  position: relative;
}

.q-ic {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.65);
  font-size: 1.05rem;
  pointer-events: none;
}

.q-input {
  border-radius: 1.25rem;
  padding: 0.9rem 3rem 0.9rem 2.6rem;
  border: 0.0625rem solid rgba(255, 255, 255, 0.14);
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.02)),
    rgba(0, 0, 0, 0.28);
  color: rgba(255, 255, 255, 0.92);
  font-weight: 850;
  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.q-input::placeholder {
  color: rgba(255, 255, 255, 0.45);
  font-weight: 800;
}

.q-input:hover {
  border-color: rgba(255, 255, 255, 0.22);
  transform: translateY(-0.04rem);
}

.q-input:focus {
  outline: none;
  border-color: rgba(255, 255, 255, 0.28);
  box-shadow:
    0 0 0 0.25rem rgba(124, 58, 237, 0.14),
    0 1.25rem 2.75rem rgba(0, 0, 0, 0.35);
}

/* Eye button */
.q-eye {
  position: absolute;
  right: 0.6rem;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 0.95rem;
  padding: 0.5rem 0.65rem;
  border: 0.0625rem solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.85);
}
.q-eye:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.18);
}

/* Meta */
.q-meta {
  font-weight: 850;
  color: rgba(255, 255, 255, 0.70);
}

.q-check {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}

.q-link {
  color: rgba(255, 255, 255, 0.86);
  font-weight: 950;
  text-decoration: none;
}
.q-link:hover {
  text-decoration: underline;
}

/* Buttons */
.q-cta {
  border-radius: 62.5rem;
  padding: 0.9rem 1.25rem;
  font-weight: 950;
  color: #fff;
  border: 0;
  background: linear-gradient(90deg, #2d6cff 0%, #7c3aed 55%, #ff3d8d 120%);
  box-shadow: 0 1.125rem 2.25rem rgba(0, 0, 0, 0.35);
  transition: transform 160ms ease, filter 160ms ease;
}
.q-cta:hover {
  transform: translateY(-0.05rem);
  filter: brightness(1.06);
}

.q-alt {
  border-radius: 1.25rem;
  padding: 0.85rem 1rem;
  font-weight: 950;
  color: rgba(255, 255, 255, 0.92);
  border: 0.0625rem solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.04);
  transition: transform 160ms ease, background 160ms ease, border-color 160ms ease;
}
.q-alt:hover {
  transform: translateY(-0.05rem);
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.26);
}

/* Divider */
.q-divider {
  position: relative;
  text-align: center;
}
.q-divider::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  height: 0.0625rem;
  background: rgba(255, 255, 255, 0.12);
}
.q-divider span {
  position: relative;
  padding: 0 0.75rem;
  background: rgba(10, 12, 18, 0.65);
  border: 0.0625rem solid rgba(255, 255, 255, 0.10);
  border-radius: 62.5rem;
  color: rgba(255, 255, 255, 0.70);
  font-weight: 950;
  font-size: 0.85rem;
}

/* Footer */
.q-foot {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  font-weight: 850;
}
.q-muted {
  color: rgba(255, 255, 255, 0.65);
}

/* Note */
.q-bottomnote {
  text-align: center;
  color: rgba(255, 255, 255, 0.62);
  font-weight: 850;
}

/* Bootstrap focus ring off */
.form-control:focus {
  box-shadow: none;
}

@media (max-width: 62rem) {
  .q-login-page {
    padding: 3rem 0 4rem;
  }
}


.q-logo {
  width: 3.1rem;
  height: 3.1rem;
  border-radius: 1.25rem;
  overflow: hidden;
  flex: 0 0 auto;
  background: rgba(255, 255, 255, 0.06);
  border: 0.0625rem solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 0.9rem 2.2rem rgba(0, 0, 0, 0.35);
}

.q-logo img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover; /* keeps logo from stretching */
  object-position: center;
}

</style>
